import React, { InputHTMLAttributes } from "react";

import { inputStyle } from "./Input.css";

export interface InputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
  type?:
    | "text"
    | "password"
    | "email"
    | "number"
    | "tel"
    | "url"
    | "search"
    | "date"
    | "time"
    | "datetime-local"
    | "month"
    | "week";
  isDisabled?: boolean;
  isInvalid?: boolean;
  isReadOnly?: boolean;
}

export const Input: React.FC<InputProps> = ({
  type = "text",
  isDisabled = false,
  isInvalid = false,
  isReadOnly = false,
  className,
  ...rest
}) => {
  const combinedClassName = `${inputStyle} ${className || ""}`.trim();

  return (
    <input
      type={type}
      className={combinedClassName}
      disabled={isDisabled}
      readOnly={isReadOnly}
      aria-invalid={isInvalid ? true : undefined}
      {...rest}
    />
  );
};
